import axios from 'axios';

class Api {
  constructor() {
    this.headers = {
      'content-type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
      'Authorization': `Bearer ${window.sessionStorage.getItem('_token')}`,
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
    };

    this.cancelToken = null;
  }

  static get $instance() {
    if (!Api.instance) {
      Api.instance = new Api();
    }

    return Api.instance;
  }

  static url(url, params) {
    if (!params) {
      return url;
    }

    Object.keys(params).forEach((param) => {
      if ({}.hasOwnProperty.call(params, param)) {
        url = url.replace(
          new RegExp(`:${param}`, 'g'),
          params[param],
        );
      }
    });

    return url;
  }

  getHeaders() {
    return this.headers;
  }

  initClient(headers = {}) {
    this.cancelToken = axios.CancelToken.source();
    this.client = axios.create({
      baseURL: `${process.env.VUE_APP_TKGATEWAY}/api/v1/`,
      headers: {
        ...this.getHeaders(),
        ...headers,
      },
    });

    return this.client;
  }

  async request(config, headers = {}) {
    this.initClient(headers);

    try {
      return await this.client.request({ ...config, cancelToken: this.cancelToken?.token });
    } catch (e) {
      return e.response;
    }
  }

  async get(url, data, config) {
    return this.request({
      method: 'GET',
      url,
      ...config,
    });
  }

  async post(url, data, config, headers = {}) {
    return this.request({
      method: 'POST',
      url,
      data,
      ...config,
    }, headers);
  }

  async put(url, data, config, headers = {}) {
    return this.request({
      method: 'PUT',
      url,
      data,
      ...config,
    }, headers);
  }

  async patch(url, data, config, headers = {}) {
    return this.request({
      method: 'PATCH',
      url,
      data,
      ...config,
    }, headers);
  }

  async delete(url, config) {
    return this.request({
      method: 'DELETE',
      url,
      ...config,
    });
  }

  dataToUrl(data) {
    const localData = { ...data };

    const result = {};

    Object.keys(localData).forEach((key) => {
      if (typeof localData[key] === 'number') {
        result[key] = String(localData[key]);

        return;
      }

      if (localData[key] === null || localData[key] === undefined) {
        return;
      }

      if (typeof localData[key] === 'object' && localData[key].length) {
        result[key] = JSON.stringify(localData[key]);

        return;
      }

      // empty arrays convert
      if (typeof localData[key] === 'object' && localData[key].length === 0) {
        result[key] = JSON.stringify([]);

        return;
      }

      // for now skip objects
      if (typeof localData[key] === 'object' && !localData[key].length) {
        return;
      }

      // brr
      if (key.toLowerCase() === 'id') {
        result[key.toLowerCase()] = localData[key];

        return;
      }

      result[key] = localData[key];
    });

    return new URLSearchParams(result).toString();
  }
}

export default Api;
